import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';

const basePath = '/api';

export interface AutoMappedDesignFile {
    fileName: string;
    fileType: number;
    fileKind: number;
    teeth?: string | null;
}

export interface SkippedDesignFile {
    fileName: string;
    reason: string;
}

export interface AutoMapDesignFilesResult {
    mapped: AutoMappedDesignFile[];
    skipped: SkippedDesignFile[];
}

@Injectable({
    providedIn: 'root',
})
export class DesignFileUploadClient {
    private readonly _http = inject(HttpClient);

    upload(treatmentId: string, designId: number, body: FormData) {
        return this._http.post(`${basePath}/treatments/${treatmentId}/designs/${designId}/files`, body, {
            observe: 'response',
            reportProgress: true,
        });
    }

    /**
     * Uploads a batch of design files without a preselected file type; the backend parses each file
     * name and maps it to the correct upload area, returning what was mapped and what was skipped.
     */
    uploadAuto(treatmentId: string, designId: number, body: FormData) {
        return this._http.post<AutoMapDesignFilesResult>(
            `${basePath}/treatments/${treatmentId}/designs/${designId}/files:auto-map`,
            body
        );
    }
}
